/* Collection hero: on mobile, set inner background-image from collection image */
(() => {
  const mq = window.matchMedia('(max-width: 749px)');

  const apply = () => {
    const hero = document.querySelector('.collection-hero--with-image');
    if (!hero) return;

    const inner = hero.querySelector('.collection-hero__inner');
    const img = hero.querySelector('.collection-hero__image-container img');
    if (!inner || !img) return;

    if (mq.matches) {
      const src = img.currentSrc || img.src;
      if (src) inner.style.setProperty('--hero-bg', `url("${src}")`);
    } else {
      inner.style.removeProperty('--hero-bg');
    }
  };

  document.addEventListener('DOMContentLoaded', apply);
  window.addEventListener('load', apply);
  mq.addEventListener?.('change', apply);
})();
